import { render } from "./AllStocks.vue?vue&type=template&id=2a46947e"
import script from "./AllStocks.vue?vue&type=script&lang=js"
export * from "./AllStocks.vue?vue&type=script&lang=js"

import "./AllStocks.vue?vue&type=style&index=0&id=2a46947e&lang=css"

import exportComponent from "C:\\Users\\oozdemir\\Documents\\GitHub\\bootstrap-sample\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__